import { SagaIterator } from "@redux-saga/types";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../../../enumerations/HttpResponseTypeEnum";
import GenerateOtpActions from "../../../redux-container/login/generate-otp/GenerateOtpRedux";

export function* generateOtp(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.generateOtp, action.data);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(GenerateOtpActions.generateOtpSuccess(response.data));
    } else {
      yield put(GenerateOtpActions.generateOtpFailure(response.data));
    }
  } catch (error) {
    yield put(GenerateOtpActions.generateOtpFailure(error));
  }
}
